import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { StudentHelperService } from '../../../service/student-helper.service';
import { StudentHelper2Service } from '../../../service/student-helper2.service';

@Component({
    selector: 'children-deduplication-compare-modal',
    templateUrl: './children-deduplication-compare-modal.component.html',
    styleUrls: ['./children-deduplication-compare-modal.component.scss']
})
export class ChildrenDeduplicationCompareModalComponent {
    studentId1: number;
    studentId2: number;

    msg: string;

    studentName1: string;
    regions1: string;
    terminated1: string;
    merged1: string;
    studentName2: string;
    regions2: string;
    terminated2: string;
    merged2: string;

    isLoading: boolean = false;

    subs: Subscription[] = [];

    constructor(
        public dialogRef: MatDialogRef<ChildrenDeduplicationCompareModalComponent>,
        private studentHelperService: StudentHelperService,
        private studentHelper2Service: StudentHelper2Service,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.subscriptions();

        if (this.data) {
            this.studentId1 = this.data.studentId1;
            this.studentId2 = this.data.studentId2;
            this.studentHelperService.setStudentId(this.studentId1);
            this.studentHelper2Service.setStudentId(this.studentId2);
        }

        this.isLoading = false;
    }

    subscriptions() {
        let studentNameSub = this.studentHelperService.studentName$.subscribe((studentName) => {
            this.studentName1 = studentName;
        });
        let studentNameSub2 = this.studentHelper2Service.studentName$.subscribe((studentName) => {
            this.studentName2 = studentName;
        });

        this.subs.push(studentNameSub);
        this.subs.push(studentNameSub2);

        let regionsSub = this.studentHelperService.regions$.subscribe((regions) => {
            this.regions1 = regions;
        });

        let regionsSub2 = this.studentHelper2Service.regions$.subscribe((regions) => {
            this.regions2 = regions;
        });

        this.subs.push(regionsSub);
        this.subs.push(regionsSub2);

        let terminatedSub = this.studentHelperService.terminated$.subscribe((terminated) => {
            this.terminated1 = terminated;
        });

        let terminatedSub2 = this.studentHelper2Service.terminated$.subscribe((terminated) => {
            this.terminated2 = terminated;
        });

        this.subs.push(terminatedSub);
        this.subs.push(terminatedSub2);

        let mergedSub = this.studentHelperService.merged$.subscribe((merged) => {
            this.merged1 = merged;
        });

        let mergedSub2 = this.studentHelper2Service.merged$.subscribe((merged) => {
            this.merged2 = merged;
        });

        this.subs.push(mergedSub);
        this.subs.push(mergedSub2);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    closeDialog(closed: boolean) {
        this.data = { msg: this.msg, closed: closed };
        this.dialogRef.close(this.data);
    }
}
